import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

// Components
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { CoreCapabilities } from "./components/CoreCapabilities";
import { PlatformSection } from "./components/PlatformSection";
import { TrustMetrics } from "./components/TrustMetrics";
import { WhatWeOffer } from "./components/WhatWeOffer";
import { Industries } from "./components/Industries";
import { WhyEasysend } from "./components/WhyBlackStripe";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";

// Legal Pages
import { DataProtectionAddendum } from "./components/DataProtectionAddendum";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { AcceptableUsePolicy } from "./components/AcceptableUsePolicy";
import { FinancialCrimeStatement } from "./components/FinancialCrimeStatement";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Navbar />
      <main>
        <HeroSection />
        <CoreCapabilities />
        <PlatformSection />
        <TrustMetrics />
        <WhatWeOffer />
        <Industries />
        <WhyEasysend />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/data-protection-addendum" element={<DataProtectionAddendum />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/acceptable-use-policy" element={<AcceptableUsePolicy />} />
          <Route path="/financial-crime-risk-appetite" element={<FinancialCrimeStatement />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
